import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateSubCategoryLookupComponent } from './template-sub-category-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TemplateSubCategoryLookupComponent],
  exports: [TemplateSubCategoryLookupComponent]
})
export class TemplateSubCategoryLookupModule { }
